module.exports = __webpack_public_path__ + "static/img/bg1-1.f0d5d9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/bg1-1.jpg
// module id = wIfN
// module chunks = 0